export async function getFileWithExactDimensions(
  img: HTMLImageElement,
  width: number,
  height: number,
  name: string,
  type: string
): Promise<File> {
  // create an off-screen canvas
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  // set its dimension to target size
  canvas.width = width
  canvas.height = height

  // draw source image into the off-screen canvas:
  // @ts-ignore
  ctx.drawImage(img, 0, 0, width, height)

  // encode image to data-uri with base64 version of compressed image
  const res: Response = await fetch(canvas.toDataURL())
  const blob: Blob = await res.blob()

  return new File([blob], name, { type })
}

export function checkIfImageIsSmall(
  img: HTMLImageElement,
  minWidth: number | null,
  minHeight: number | null
): boolean {
  if (
    (!!minWidth && img.width < minWidth) ||
    (!!minHeight && img.height < minHeight)
  ) {
    return true
  }
  return false
}

// GIF byte markers
const EXTENSION_INTRODUCER = 0x21
const GRAPHIC_CONTROL_LABEL = 0xf9

/**
 * Counts the number of frames in a GIF by parsing the binary data.
 * May be off by 1-2 frames, which is acceptable for a soft warning.
 */
export async function getGifFrameCount(file: File): Promise<number> {
  const buffer = await file.arrayBuffer()
  const bytes = new Uint8Array(buffer)

  // Walk through the GIF byte stream and count Graphic Control Extension blocks.
  // A GCE block always begins with:
  //   0x21 → "Extension Introducer" (signals that an extension block starts)
  //   0xF9 → "Graphic Control Label" (identifies the extension type)
  // In animated GIFs, there is typically one GCE immediately before each frame.
  let frameCount = 0
  for (let i = 0; i < bytes.length - 1; i++) {
    if (
      bytes[i] === EXTENSION_INTRODUCER &&
      bytes[i + 1] === GRAPHIC_CONTROL_LABEL
    ) {
      frameCount++
    }
  }

  return frameCount || 1
}
